import { useState } from 'react';
import { useGetInventoryControlQuery } from '@/services/api/inventory/inventoryApi';

/**
 * Custom hook for managing inventory data
 * Provides pagination and search functionality for inventory items
 */
export const useInventoryData = () => {
  // ==========================================
  // Pagination State
  // ==========================================
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
  });

  // ==========================================
  // Search State
  // ==========================================
  const [search, setSearch] = useState("");

  // ==========================================
  // Pagination Handlers
  // ==========================================
  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, page }));
  };

  const handlePageSizeChange = (per_page) => {
    setPagination({ page: 1, per_page });
  };

  // ==========================================
  // Search Handler
  // ==========================================
  const handleSearch = (searchTerm) => {
    const trimmedSearch = searchTerm.trim();
    setSearch(trimmedSearch);
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  // ==========================================
  // RTK Query with proper configuration
  // ==========================================
  const {
    data: datResponse = {},
    isLoading,
    isFetching,
    error,
    refetch
  } = useGetInventoryControlQuery(
    {
      page: pagination.page,
      per_page: pagination.per_page,
      search: search,
    },
    {
      // This ensures the query refetches when parameters change
      refetchOnMountOrArgChange: true,
      // Skip the query if no valid parameters (optional)
      skip: false,
    }
  );

  // Extract data from response structure
  // API returns pagination object with { data: [...], current_page, per_page, total }
  const apiResponse = datResponse?.data || {};
  const inventoryData = apiResponse.data || [];
  const count = datResponse?.counts || {};
  const paginationInfo = {
    current_page: apiResponse.current_page || 1,
    last_page: apiResponse.last_page || 1,
    per_page: apiResponse.per_page || 10,
    total: apiResponse.total || 0,
  };


  // console.log(apiResponse, "Fetched  API Inventory Data");
  // console.log(apiResponse, "Fetched Inventory Data");
  return {
    // Data
    inventoryData,
    apiResponse,
    count,
    
    // Pagination info
    paginationInfo,
    
    // Pagination handlers
    handlePageChange,
    handlePageSizeChange,
    
    // Search state and handler
    search,
    handleSearch,
    
    // Loading states
    isLoading,
    isFetching,
    
    // Error states
    error,
    isError: !!error,
    
    // Actions
    refetch
  };
};